import { render, staticRenderFns } from "./AssetImageLinkUpdate.vue?vue&type=template&id=982b0078&"
import script from "./AssetImageLinkUpdate.vue?vue&type=script&lang=js&"
export * from "./AssetImageLinkUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports